var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _vm.customQuestions.length === 0
        ? _c("p", { staticClass: "mb-0 text-xs-center" }, [
            _vm._v("\n    There are no questions to answer here\n  ")
          ])
        : _c(
            "v-card-text",
            { staticClass: "pa-0" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { id: "questionArea", row: "", wrap: "" } },
                    _vm._l(_vm.customQuestionList, function(question, idx) {
                      return _c(
                        "v-flex",
                        {
                          key: idx,
                          attrs: { xs12: "", md6: "", lg3: "", "pa-2": "" }
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "", "max-width": "400" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attr = ref.attr
                                      return [
                                        _c(
                                          "div",
                                          _vm._g({}, on),
                                          [
                                            _vm.getType(question.Type) ===
                                            "select"
                                              ? _c("v-autocomplete", {
                                                  attrs: {
                                                    id: "Question_1",
                                                    items:
                                                      _vm.optionsMap[
                                                        question.ID
                                                      ] || [],
                                                    loading: !!_vm
                                                      .loadingOptions[
                                                      question.ID
                                                    ],
                                                    "search-input":
                                                      _vm.searchInput[
                                                        "question_" +
                                                          question.ID
                                                      ],
                                                    rules: _vm.getAutoCompleteRules(
                                                      question
                                                    ),
                                                    "hide-no-data": "",
                                                    "hide-selected": "",
                                                    "item-text": "Description",
                                                    "item-value": "API",
                                                    label: question.Question,
                                                    placeholder: question.newValue
                                                      ? undefined
                                                      : "Start typing to Search",
                                                    "return-object": "",
                                                    chips: "",
                                                    "deletable-chips": "",
                                                    hint: question.AllowMultiple
                                                      ? "You can select multiple answers"
                                                      : undefined,
                                                    "persistent-hint": "",
                                                    multiple:
                                                      question.AllowMultiple
                                                  },
                                                  on: {
                                                    "update:searchInput": function(
                                                      $event
                                                    ) {
                                                      return _vm.$set(
                                                        _vm.searchInput,
                                                        "question_" +
                                                          question.ID,
                                                        $event
                                                      )
                                                    },
                                                    "update:search-input": function(
                                                      $event
                                                    ) {
                                                      return _vm.$set(
                                                        _vm.searchInput,
                                                        "question_" +
                                                          question.ID,
                                                        $event
                                                      )
                                                    },
                                                    input: function(v) {
                                                      _vm.updateValue(question)
                                                    }
                                                  },
                                                  model: {
                                                    value: question.newValue,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        question,
                                                        "newValue",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "question.newValue"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", { staticClass: "break-word" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(question.Question) +
                                    "\n            "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "", "max-width": "400" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attr = ref.attr
                                      return [
                                        _c(
                                          "div",
                                          _vm._g({}, on),
                                          [
                                            _vm.getType(question.Type) ===
                                            "Text"
                                              ? _c("v-text-field", {
                                                  attrs: {
                                                    id: "Question_2",
                                                    label: question.Question,
                                                    placeholder:
                                                      question.Question,
                                                    type:
                                                      question.Category ==
                                                      "Account Versions"
                                                        ? "number"
                                                        : "text",
                                                    counter:
                                                      question.CharacterLimit,
                                                    maxlength:
                                                      question.CharacterLimit,
                                                    rules: question.Mandatory
                                                      ? _vm.rules.textFilled
                                                      : _vm.rules.notOnlySpaces
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.updateValue(
                                                        question
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: question.newValue,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        question,
                                                        "newValue",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "question.newValue"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", { staticClass: "break-word" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(question.Question) +
                                    "\n            "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "", "max-width": "400" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attr = ref.attr
                                      return [
                                        _c(
                                          "div",
                                          _vm._g({}, on),
                                          [
                                            _vm.getType(question.Type) ===
                                            "TextArea"
                                              ? _c("v-textarea", {
                                                  attrs: {
                                                    id: "Question_3",
                                                    "auto-grow": "",
                                                    rows: 3,
                                                    label: question.Question,
                                                    placeholder:
                                                      question.Question,
                                                    rules: question.Mandatory
                                                      ? _vm.rules.textFilled
                                                      : []
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.updateValue(
                                                        question
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: question.newValue,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        question,
                                                        "newValue",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "question.newValue"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", { staticClass: "break-word" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(question.Question) +
                                    "\n            "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.getType(question.Type) === "Checkbox"
                            ? _c(
                                "div",
                                { staticClass: "mr-1" },
                                [
                                  _c(
                                    "v-input",
                                    {
                                      staticClass: "checkbox_type_question",
                                      attrs: {
                                        id: "Question_4",
                                        value: question.newValue,
                                        rules: question.Mandatory
                                          ? _vm.rules.checkBoxRules
                                          : []
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.updateValue(question)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(question.Question) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.getType(question.Type) === "Checkbox"
                            ? _c(
                                "div",
                                { staticClass: "checkboxOptions mr-1" },
                                _vm._l(question.Options, function(
                                  option,
                                  index
                                ) {
                                  return _c("v-checkbox", {
                                    key: index,
                                    staticClass: "sb_checkbox",
                                    attrs: {
                                      id: "Question_5",
                                      label: option,
                                      value: option
                                    },
                                    on: {
                                      change: function(v) {
                                        question.newValue = question.checkBoxValue.join()
                                        _vm.updateValue(question)
                                      }
                                    },
                                    model: {
                                      value: question.checkBoxValue,
                                      callback: function($$v) {
                                        _vm.$set(question, "checkBoxValue", $$v)
                                      },
                                      expression: "question.checkBoxValue"
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.getType(question.Type) === "Label"
                            ? _c("div", {
                                staticClass: "title",
                                domProps: {
                                  innerHTML: _vm._s(question.Question)
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }